import { CallBlack } from "./call_black";
import { CarRental } from "./car_rental";
import { Chat } from "./chat";
import { ChatBubble } from "./chat_bubble";
import { CheckCircle } from "./check_circle";
import { CleanHands } from "./clean_hands";
import { Collections } from "./collections";
import { CollectionsBookmark } from "./collections_bookmark";
import { Construction } from "./construction";
import { ContactSupport } from "./contact_support";
import { ContentPaste } from "./content_paste";
import { Copyright } from "./copyright";
import { Coronavirus } from "./coronavirus";

const iconsList = [
  { label: "CallBlack", code: <CallBlack /> },
  { label: "CarRental", code: <CarRental /> },
  { label: "Chat", code: <Chat /> },
  { label: "ChatBubble", code: <ChatBubble /> },
  { label: "CheckCircle", code: <CheckCircle /> },
  { label: "CleanHands", code: <CleanHands /> },
  { label: "Collections", code: <Collections /> },
  { label: "CollectionsBookmark", code: <CollectionsBookmark /> },
  { label: "Construction", code: <Construction /> },
  { label: "ContactSupport", code: <ContactSupport /> },
  { label: "ContentPaste", code: <ContentPaste /> },
  { label: "Copyright", code: <Copyright /> },
  { label: "Coronavirus", code: <Coronavirus /> },
];

export {
  iconsList,
  CallBlack,
  CarRental,
  Chat,
  ChatBubble,
  CheckCircle,
  CleanHands,
  Collections,
  CollectionsBookmark,
  Construction,
  ContactSupport,
  ContentPaste,
  Copyright,
  Coronavirus,
};
